// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__c4-wJ","Primary":"Button_Primary__Olzvs","Secondary":"Button_Secondary__uKzRp","Disabled":"Button_Disabled__FPxsg","Icon":"Button_Icon__MjICK"};